var React = require('react');

function ShadowSInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"filter":"url(#filter0_f)","key":0},React.createElement("ellipse",{"cx":"337.5","cy":"337.5","rx":"187.5","ry":"187.5","transform":"rotate(-90 337.5 337.5)","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("filter",{"id":"filter0_f","x":"0","y":"0","width":"675","height":"675","filterUnits":"userSpaceOnUse","colorInterpolationFilters":"sRGB"},[React.createElement("feFlood",{"floodOpacity":"0","result":"BackgroundImageFix","key":0}),React.createElement("feBlend",{"mode":"normal","in":"SourceGraphic","in2":"BackgroundImageFix","result":"shape","key":1}),React.createElement("feGaussianBlur",{"stdDeviation":"75","result":"effect1_foregroundBlur","key":2})]))]);
}

ShadowSInline.defaultProps = {"width":"675","height":"675","viewBox":"0 0 675 675","fill":"none"};

module.exports = ShadowSInline;

ShadowSInline.default = ShadowSInline;
